/**
 * Logger utilitário que desabilita console.logs em produção
 * Melhora performance removendo overhead de logging
 */

const isDevelopment = process.env.NODE_ENV === 'development';

export const logger = {
  log: isDevelopment ? console.log.bind(console) : () => {},
  error: console.error.bind(console), // Sempre manter erros
  warn: isDevelopment ? console.warn.bind(console) : () => {},
  info: isDevelopment ? console.info.bind(console) : () => {},
  debug: isDevelopment ? console.debug.bind(console) : () => {},
};
